export interface StrokePayload {
    id: number
    name: string
    slug: string
    type: string
    sort_order: number
}

export class Stroke {

    id: number
    name: string
    slug: string
    type: string
    sortOrder: number

    constructor(data: StrokePayload) {
        this.id = data.id
        this.name = data.name
        this.slug = data.slug
        this.type = data.type
        this.sortOrder = data.sort_order
    }

    fill(data: StrokePayload): this {
        this.id = data.id
        this.name = data.name
        this.slug = data.slug
        this.type = data.type
        this.sortOrder = data.sort_order
        return this
    }

    exists(): boolean {
        return !! this.id
    }

    unset(): void {
        this.fill(<StrokePayload>{})
    }

    payload(): StrokePayload | any {
        return {
            id: this.id,
            name: this.name,
            slug: this.slug,
            sort_order: this.sortOrder,
        }
    }
}
